/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const storeLocatorSideListTitleTypographySX: SxProps = {
	whiteSpace: 'normal',
	fontSize: '20px',
	fontWeight: 700,
	marginBottom: '18px'
};
